import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { ScorecardItemComponent } from './scorecard-item/scorecard-item.component';
import { ScorecardComparisonComponent } from './scorecard-comparison/scorecard-comparison.component';

@NgModule({
    declarations: [ScorecardItemComponent, ScorecardComparisonComponent],
    imports: [SharedModule],
    exports: [ScorecardItemComponent, ScorecardComparisonComponent]
})
export class ScorecardModule {}
